import React, { Suspense } from 'react'

import { IS_PRODUCTION } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'

import { useDevTools } from './DevToolsProvider'

const DevToolsModal = React.lazy(() =>
  import(/* webpackChunkName: "DevToolsModal" */ './DevToolsModal').then((module) => ({
    default: module.DevToolsModal,
  })),
)

export const DevToolsModalWrapper: React.FC = () => {
  const { isDevToolsOpen } = useDevTools()

  if (IS_PRODUCTION || !isDevToolsOpen) {
    return null
  }

  return (
    <Suspense fallback={null}>
      <DevToolsModal />
    </Suspense>
  )
}
